module.exports = __webpack_public_path__ + "static/quizbaker1-beeb8adb9ecf0122d38ee6c27a0a67ea.png";